import type * as api from '@gitbook/api-client';
import type { NavigationScreenState } from '@gitbook/app-navigation';

/**
 * Whether the site-centric sidebar should render organization-level navigation.
 */
export function shouldShowOrgContentSidebar(
    screen: NavigationScreenState,
    orgAllContent: api.OrganizationAllContent
) {
    if (isOrgLevelScreen(screen)) {
        return true;
    }

    const siteId = 'site' in screen ? screen.site : undefined;
    if (!siteId) {
        return false;
    }

    // If the site ID in the URL doesn't match a site in the org
    // we show the org content sidebar and a `Not found` screen.
    return !orgAllContent.sites.some((item) => item.site.id === siteId);
}

/**
 * Check whether a navigation screen belongs to the organization-level content sidebar.
 */
export function isOrgLevelScreen(screen: NavigationScreenState) {
    return (
        ['agents', 'home', 'sites', 'org_content', 'styleguides', 'trash'].includes(screen.type) ||
        (screen.type === 'space' && !screen.site)
    );
}
